module.exports = __webpack_public_path__ + "static/media/icon-photos.0d36d7c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-photos.svg
// module id = 556
// module chunks = 0